import React from 'react';

import {Button, LoadingSpinner} from '@albert-io/atomic';
import {useStudentDashboard} from '../StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional {
  inert?: boolean;
}

export default function JoinClassroomSubmitButton({className, inert = false}: Props) {
  const isError = useStudentDashboard((state) => state.isStudentEnrollmentError);
  const isRequestPending = useStudentDashboard((state) => state.isStudentEnrollmentPending);
  const value = useStudentDashboard((state) => state.classroomCode);

  return (
    <Button
      aria-label='Submit code'
      className={className}
      data-testid='join-code-form__submit'
      disabled={inert || isRequestPending || isError || value === ''}
      type='submit'
    >
      {isRequestPending && !inert ? (
        <LoadingSpinner bottomMarginLevel={0} className='px-x3' />
      ) : (
        'Join Class'
      )}
    </Button>
  );
}
